import React, { useState, useEffect } from 'react';
import DateTimePicker from 'react-datetime-picker';

/**
 * Reusable date-time picker component that integrates with our existing
 * handleChange logic by dispatching a synthetic event with the expected
 * shape (target: { name, value }).
 *
 * Props:
 * - name:             form field name (required)
 * - value:            string in `YYYY-MM-DDTHH:mm` format (optional)
 * - onChange:         change handler receiving synthetic event (required)
 * - error:            validation error string to show below picker (optional)
 * - disabled:         disable picker (optional)
 */
const DateTimeInput = ({ name, value, onChange, error, disabled }) => {
  const [internalValue, setInternalValue] = useState(value ? new Date(value) : null);

  useEffect(() => {
    setInternalValue(value ? new Date(value) : null);
  }, [value]);

  const handlePickerChange = (val) => {
    setInternalValue(val);
    if (onChange) {
      const event = { target: { name, value: val ? formatForSubmit(val) : '' } };
      onChange(event);
    }
  };

  const formatForSubmit = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  return (
    <div className="w-full">
      <DateTimePicker
        onChange={handlePickerChange}
        value={internalValue}
        format="y-MM-dd HH:mm"
        calendarIcon={undefined}
        clearIcon={undefined}
        disableClock={false}
        className={`w-full ${error ? 'border-red-300' : ''}`}
        disabled={disabled}
        closeWidgets
        // Make sure picking a date/time closes the widget to avoid extra clicks
        shouldCloseWidgets={() => true}
      />
      {error && (<p className="mt-1 text-sm text-red-600">{error}</p>)}
    </div>
  );
};

export default DateTimeInput; 